import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from 'app/store';
import { fetchMembersFilterList } from 'api/membersFilterList';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { IMemberShortInfo } from '../memberInfo/memberInfoTypes';

export const getMembersFilterList = createAsyncThunk<
  { list: IMemberShortInfo[]; count: number },
  void,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@membersFilterList/getMembersFilterList', async (_, thunkApi) => {
  try {
    const res = await fetchMembersFilterList();
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
